import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-46dd909f")

_pushScopeId("data-v-46dd909f")
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-10 account-details-layout" }
const _hoisted_4 = { class: "me-7 mb-4 account-details-avatar" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative avatar-with-badge" }
const _hoisted_6 = {
  key: 0,
  class: "rank-prime-badge"
}
const _hoisted_7 = { class: "flex-grow-1 account-details-info" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2 account-details-title" }
const _hoisted_9 = { class: "d-flex flex-column account-details-user" }
const _hoisted_10 = { class: "d-flex align-items-center mb-2 account-details-name" }
const _hoisted_11 = {
  href: "javasript:;",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_12 = {
  key: 0,
  href: "javascript:;"
}
const _hoisted_13 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_14 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2 account-details-meta" }
const _hoisted_15 = {
  href: "javascript:;",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_16 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_17 = {
  href: "javascript:;",
  class: "d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
}
const _hoisted_18 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_19 = {
  href: "javascript:;",
  class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2"
}
const _hoisted_20 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_21 = { class: "d-flex flex-wrap flex-stack account-details-stats" }
const _hoisted_22 = { class: "d-flex flex-column flex-grow-1 pe-8 account-details-stats-wrapper" }
const _hoisted_23 = { class: "d-flex flex-wrap account-details-stats-row" }
const _hoisted_24 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_25 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_27 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "All USID Balance", -1)
const _hoisted_29 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_30 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_32 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_33 = { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }
const _hoisted_34 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_35 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_37 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "EC Wallet", -1)
const _hoisted_39 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_40 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_41 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_42 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_43 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "MG Pay", -1)
const _hoisted_44 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_45 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_46 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-danger me-2" }, null, -1)
const _hoisted_47 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Travel GC", -1)
const _hoisted_49 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_50 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_51 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_52 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Product GC", -1)
const _hoisted_54 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_55 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_57 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Sponsor ID", -1)
const _hoisted_59 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_60 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_61 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_62 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Upline ID", -1)
const _hoisted_64 = {
  key: 2,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_65 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_66 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_67 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_68 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Position", -1)
const _hoisted_69 = {
  key: 3,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_70 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_71 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_72 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Date Of Registration", -1)
const _hoisted_74 = {
  key: 4,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_75 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_76 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_77 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_78 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, " * PCP Enrollment", -1)
const _hoisted_79 = {
  key: 5,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_80 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_81 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_82 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_83 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Total Purchased PCP Product", -1)
const _hoisted_84 = {
  key: 6,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_85 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_86 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_87 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_88 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Target Milestone", -1)
const _hoisted_89 = {
  key: 0,
  class: "account-details-footnote"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _withDirectives(_createVNode("div", null, [
          _createVNode(_component_el_skeleton, {
            rows: 2,
            animated: ""
          })
        ], 512), [
          [_vShow, _ctx.loadingBalance]
        ]),
        _withDirectives(_createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("img", {
              src: _ctx.user.avatar,
              alt: "Profile photo"
            }, null, 8, ["src"]),
            (_ctx.showRankImage)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode("img", {
                    src: _ctx.rankPrimeImage,
                    alt: "Rank",
                    class: "rank-prime-img"
                  }, null, 8, ["src"])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, !_ctx.loadingBalance]
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("a", _hoisted_11, _toDisplayString(_ctx.user.fname) + " " + _toDisplayString(_ctx.user.lname), 1),
                (!_ctx.isBiboPremium)
                  ? (_openBlock(), _createBlock("a", _hoisted_12, [
                      _createVNode("span", _hoisted_13, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Verified.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("a", _hoisted_15, [
                  _createVNode("span", _hoisted_16, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/User.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.user.usid), 1)
                ]),
                _createVNode("a", _hoisted_17, [
                  _createVNode("span", _hoisted_18, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Map/Marker1.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.user.address), 1)
                ]),
                _createVNode("a", _hoisted_19, [
                  _createVNode("span", _hoisted_20, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Mail-at.svg" })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.user.email), 1)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_21, [
            _createVNode("div", _hoisted_22, [
              _withDirectives(_createVNode("div", null, [
                _createVNode(_component_el_skeleton, {
                  rows: 2,
                  animated: ""
                })
              ], 512), [
                [_vShow, _ctx.loadingBalance]
              ]),
              _withDirectives(_createVNode("div", _hoisted_23, [
                _withDirectives(_createVNode("div", _hoisted_24, [
                  _createVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createVNode("div", _hoisted_27, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.accountdetailsdata.overAllAvailableBalance).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                  ]),
                  _hoisted_28
                ], 512), [
                  [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp']
                ]),
                _withDirectives(_createVNode("div", _hoisted_29, [
                  _createVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode("div", _hoisted_32, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.accountdetailsdata.balance).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                  ]),
                  _createVNode("div", _hoisted_33, _toDisplayString(_ctx.user.usid) + " Balance", 1)
                ], 512), [
                  [_vShow, !_ctx.loadingBalance && _ctx.pt != 'pcp']
                ]),
                _withDirectives(_createVNode("div", _hoisted_34, [
                  _createVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _createVNode("div", _hoisted_37, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.accountdetailsdata.ewalletbalance).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                  ]),
                  _hoisted_38
                ], 512), [
                  [_vShow, !_ctx.loadingBalance  && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp']
                ]),
                _withDirectives(_createVNode("div", _hoisted_39, [
                  _createVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode("div", _hoisted_42, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.accountdetailsdata.matchinpaybalance).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                  ]),
                  _hoisted_43
                ], 512), [
                  [_vShow, !_ctx.loadingBalance  && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp' && _ctx.ccode === 0]
                ]),
                _withDirectives(_createVNode("div", _hoisted_44, [
                  _createVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _createVNode("div", _hoisted_47, _toDisplayString(_ctx.accountdetailsdata.travelgc), 1)
                  ]),
                  _hoisted_48
                ], 512), [
                  [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp']
                ]),
                _withDirectives(_createVNode("div", _hoisted_49, [
                  _createVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createVNode("div", _hoisted_52, _toDisplayString(_ctx.accountdetailsdata.productgc), 1)
                  ]),
                  _hoisted_53
                ], 512), [
                  [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp']
                ]),
                (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
                  ? (_openBlock(), _createBlock("div", _hoisted_54, [
                      _createVNode("div", _hoisted_55, [
                        _hoisted_56,
                        _createVNode("div", _hoisted_57, _toDisplayString(_ctx.pcpdetails.spid), 1)
                      ]),
                      _hoisted_58
                    ]))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createBlock("div", _hoisted_59, [
                      _createVNode("div", _hoisted_60, [
                        _hoisted_61,
                        _createVNode("div", _hoisted_62, _toDisplayString(_ctx.pcpdetails.upid), 1)
                      ]),
                      _hoisted_63
                    ]))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createBlock("div", _hoisted_64, [
                      _createVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _createVNode("div", _hoisted_67, _toDisplayString(_ctx.pcpdetails.upref == 'L' ? 'Left' : (_ctx.pcpdetails.upref == 'R' ? 'Right' : '')), 1)
                      ]),
                      _hoisted_68
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
                  ? (_openBlock(), _createBlock("div", _hoisted_69, [
                      _createVNode("div", _hoisted_70, [
                        _hoisted_71,
                        _createVNode("div", _hoisted_72, _toDisplayString(_ctx.formatDateMonthDayYear(_ctx.pcpdetails.regDate)), 1)
                      ]),
                      _hoisted_73
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
                  ? (_openBlock(), _createBlock("div", _hoisted_74, [
                      _createVNode("div", _hoisted_75, [
                        _hoisted_76,
                        _createVNode("div", _hoisted_77, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpdetails.pcpEnrollmentFee).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                      ]),
                      _hoisted_78
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
                  ? (_openBlock(), _createBlock("div", _hoisted_79, [
                      _createVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _createVNode("div", _hoisted_82, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpdetails.pcp_product_total).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                      ]),
                      _hoisted_83
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
                  ? (_openBlock(), _createBlock("div", _hoisted_84, [
                      _createVNode("div", _hoisted_85, [
                        _hoisted_86,
                        _createVNode("div", _hoisted_87, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpdetails.nextMilestone).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                      ]),
                      _hoisted_88
                    ]))
                  : _createCommentVNode("", true)
              ], 512), [
                [_vShow, !_ctx.loadingBalance]
              ]),
              (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
                ? (_openBlock(), _createBlock("p", _hoisted_89, "* PCP Enrollment includes " + _toDisplayString(_ctx.pcpdetails.pcpEnrollmentInclusions), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
})